<template>
	<div class="header-container color-bg-primary">
		<div class="header-logo" @click="goToHome()" style="cursor: pointer;">
			<!-- <img v-show="status.logo === 'nodata'" src="../../assets/image/login-header-logoV2.png" alt=""> -->
			<img v-show="status.logo === 'loading'" src="../../../../common/src/assets/loading.gif" alt="">
			<img v-show="status.logo === 'havedata'" :src="companyLogo" alt="">
		</div>
		<div class="header-info">
			<div class="header-info-left">
				<!--<div class="product-container product-bg" :class="showProduct ? 'show' : 'hide'">
					<div class="product-item" v-for="(item, index) in product">
						<div class="product-title">
							{{item.name}}
						</div>
						<div class="product-content">
							<div class="product-content-item" v-for="(listItem, index) in item.list"
									@click="skip(listItem.url)">
								{{listItem.name}}
							</div>
						</div>
					</div>
				</div>
				<p class="color-white" slot="reference" id="product-container">
					产品与服务
					<i class="icon icon-down font-mini"></i>
				</p>-->
				<efly-popover top="56px" trigger="hover">
					<div class="product-container">
						<div class="product-item" v-for="(item, index) in product">
							<div class="product-title">
								{{item.name}}
							</div>
							<div class="product-content">
								<div class="product-content-item" v-for="(listItem, index) in item.list"
									 @click="skip(listItem.url)">
									{{listItem.name}}
								</div>
							</div>
						</div>
					</div>
					<p class="color-white" slot="reference">
						产品与服务
						<i class="icon icon-down font-mini"></i>
					</p>
				</efly-popover>
			</div>
			<div class="header-info-right box flex-align-center">
				<div class="mar-r-big help-nav" @click="gotoHelpPage()">
					帮助
				</div>
				<efly-popover top="56px">
					<div class="header-account-layer">
						<div class="header-account-layer-label">
							{{userInfo.accountName | StarInfoPipe('set')}}
						</div>
						<div class="header-account-layer-tabs">
							<div class="header-account-layer-tabs-item" @click="skip('/user/user/frontInfo')">
								<i class="icon icon-userinfo"></i>
								<span>基本信息</span>
							</div>
							<div class="header-account-layer-tabs-item" @click="skip('/user/user/securitySettings')">
								<i class="icon icon-security-settings" ></i>
								<span>安全设置</span>
							</div>
							<div class="header-account-layer-tabs-item" @click="skip('/user/user/securitySettings')">
								<i class="icon icon-modify-password"></i>
								<span>修改密码</span>
							</div>
							<div class="header-account-layer-tabs-item" @click="skip('/user/user/securitySettings')">
								<i class="icon icon-modify-phone"></i>
								<span>修改手机</span>
							</div>
							<div class="header-account-layer-tabs-item" @click="skip(verifyUrl)">
								<i class="icon icon-Verification"></i>
								<span>实名认证</span>
							</div>
						</div>
						<div class="header-account-layer-exit" @click="exit()">
							退出登录
						</div>
					</div>
					<div class="header-account" slot="reference">
						{{userInfo.accountName  | StarInfoPipe('set')}}
					</div>
				</efly-popover>
			</div>
		</div>
	</div>
</template>

<script>
    import HeaderNav from './header-nav';

    export default HeaderNav;
</script>

<style lang="scss" >
.header-container.color-bg-primary {
	background-image: linear-gradient(#0082f6, #009bf0);
	.header-info .header-info-right .header-account,.color-white {
		color: #fff;
	}

	.header-info-right{
		.help-nav {
			color: #fff;
			cursor: pointer;
		}
		.efly-popover-layer{
			box-shadow: 0 2px 10px #ddd;
			left: unset!important;
			right: 0px;
		}
	}
	.header-info-left {
		cursor: pointer;
		.color-white {
			line-height: 56px;
		}
	}
	.product-bg {
		top: 56px;
		z-index: 100;
		position: absolute;
		background: #fff;
		box-shadow: 0 0 4px #cfcfcf;
		display: none !important;
	}
	.show {
		display: flex !important;
	}
	.hide {
		display: none !important;
	}
	.header-logo {
		img {
			max-height: 50px;
			max-width: 180px;
		}
	}
}
</style>
